
import { FC } from 'react';
import { BackButton } from '@/components/whatsapp-community/BackButton';
import { CommunityHero } from '@/components/whatsapp-community/CommunityHero';
import { FeatureCards } from '@/components/whatsapp-community/FeatureCards';
import { CallToAction } from '@/components/whatsapp-community/CallToAction';
import { AppDownloadButtons } from '@/components/whatsapp-community/AppDownloadButtons';

export const WhatsAppCommunity: FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-indigo-50 to-blue-50 dark:from-indigo-950 dark:to-blue-950">
      <div className="w-full max-w-6xl">
        <BackButton />
        <CommunityHero />
        <AppDownloadButtons />
        <FeatureCards />
        <CallToAction whatsappLink="" />
      </div>
    </div>
  );
};

export default WhatsAppCommunity;
